var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyToDocumentTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.286 11 31 16.588V28a2 2 0 0 1-2 2H15.25a2 2 0 0 1-2-2l-.001-3.483c.391.111.8.2 1.224.265l.027.003V28c0 .414.336.75.75.75H29a.75.75 0 0 0 .75-.75V17.147h-3.321a1.714 1.714 0 0 1-1.715-1.714V12.25H15.25a.75.75 0 0 0-.75.75v5.426l-.105-.025a3.04 3.04 0 0 1-1.146-.56L13.25 13a2 2 0 0 1 2-2h10.036zm2.571 13.691v1.397H18.96l1.397-1.397h7.501zm0-3.353v1.397h-5.545l1.016-1.015-.383-.382h4.912z",
  fill: "#0481A0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.75 14c.333 4.667 2.583 6.84 6.75 6.52v-2.8l4 4-4 4v-2.8c-5 .053-7.583-2.92-7.75-8.92h1zM23 4.5V9h-1.5l-3.151-3.151L6.35 5.85v10.8l.641.001c.078.469.173.919.287 1.35L5 18V4.5h18z",
  fill: "#707070"
}))));
export default SvgCopyToDocumentTool;